<template>
    <div>
        <h1>{{ $t('betalingsmuligheder')}}</h1>
        
        <!-- Vis 'loading' ikon mens API data loader... -->
        <img v-if="this.$store.getters.loading === true" src="@/assets/loading.svg" alt="">

        <div>
            <!-- {{this.$store.getters.bookingInProgress}}<br /> -->
            <!-- {{this.$store.getters.summaryData}} <br /> -->
            <!-- <p>Loading: {{this.$store.getters.loading}}</p> -->
            <!-- {{this.$store.getters.bookingInProgress.hotel}}<br /> -->
            <!-- <p>{{this.$store.getters.paymentPriceData}}</p> -->
            <!-- <p>Totalpris: {{ this.$store.getters.summaryData.totals.totalPriceInclVat }}</p> -->
            <!-- <p>Checksum: {{ this.QuickPayForm.checksum }} eller {{ this.$store.getters.checksum }}</p> -->
            <!-- <p>Rabat: {{ this.$store.getters.summaryData.totals }}</p> -->
            <!-- <p>discountCode: {{ this.$store.getters.discountCode }}</p> -->
            <!-- <p>apiLoaded: {{ this.apiLoaded }}</p> -->
            <!-- <p>apiLoading: {{ this.$store.getters.loading }}</p> -->
            <!-- {{this.$store.getters.hotels}}<br /> -->
            <!-- <p>Koncern: {{ this.$route.params.koncern }}</p> -->
        </div>

        <div class="paymentContainer">                           

            <!-- Test -->
            <!-- <div class="paymentOption" v-if="moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}).isSameOrAfter(moment().startOf('day').add({'hour': 12, 'minute': 0, 'second': 1}))">
                <p>Ankomstdato ikke indenfor 24 timer, vis bankxfer</p>
                <p>ankomst: {{ moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}) }} nu: {{ moment().startOf('day').add({'hour': 12, 'minute': 0, 'second': 1}) }}</p>
            </div>
            <div class="paymentOption" v-else>
                <p>Ankomstdato er indenfor 24 timer, vis ikke bankxfer</p>
                <p>ankomst: {{ moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}) }} nu: {{ moment().startOf('day').add({'hour': 12, 'minute': 0, 'second': 1}) }}</p>
            </div> -->

<!--             <div class="paymentOption bankxfer" v-if="(moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}).isSameOrAfter(moment().startOf('day').add({'hour': 12, 'minute': 0, 'second': 1})) || $store.getters.summaryData.totals.totalDiscount > 0 )">
                <p>{{ $store.getters.bookingInProgress.startdate }}</p>
                <p>Denne: {{ moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}) }}</p>
                <p> er samme eller efter denne: {{ moment().startOf('day').add({'hour': 12, 'minute': 0, 'second': 0}) }}</p>
                <p>{{ moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}).isSameOrAfter(moment().startOf('day').add({'hour': 12, 'minute': 0, 'second': 0})) }}</p>
            </div> -->

            <div v-for="payment in this.$store.getters.paymentPriceData" v-bind:key="payment.id_rec">

                <!-- Betalingskort -->
                <div class="paymentOption creditcard" v-if="payment.room === 'creditcard' && $store.getters.summaryData.totals.totalPriceInclVat > 0" v-on:click="handleCreditCard()">
                <!-- 
                1. api-kald til createRefNo
                2. når 1. er færdig, api-kald til at beregne checksum til QuickPay-form
                3. når 2. er færdig, tryk på 'submit' på den hidden QuickPay-form vi har indsat
                -->
                    <form v-if="$store.getters.checksum" method="POST" action="https://payment.quickpay.net" ref="qpForm">
                        <input v-bind:value="$store.getters.checksum.version" type="hidden" name="version">
                        <input v-bind:value="$store.getters.checksum.merchant_id" type="hidden" name="merchant_id">
                        <input v-bind:value="$store.getters.checksum.agreement_id" type="hidden" name="agreement_id">
                        <input v-bind:value="$store.getters.checksum.order_id" type="hidden" name="order_id">
                        <input v-bind:value="$store.getters.checksum.amount" type="hidden" name="amount">
                        <input v-bind:value="$store.getters.checksum.currency" type="hidden" name="currency">
                        <input v-bind:value="$store.getters.checksum.payment_methods" type="hidden" name="payment_methods">
                        <input v-bind:value="$store.getters.checksum.continueurl" type="hidden" name="continueurl">
                        <input v-bind:value="$store.getters.checksum.cancelurl" type="hidden" name="cancelurl">
                        <input v-bind:value="$store.getters.checksum.callbackurl" type="hidden" name="callbackurl">
                        <input v-bind:value="$store.getters.checksum.checksum" type="hidden" name="checksum">
                    </form>

                    <p class="headerText">{{ $t('betalingskort') }}</p>
                    <p class="priceText">{{ $t('pris') }} {{payment.pris}} kr.</p>
                </div>

                <!-- Bankoverførsel og EAN bliver kun vist hvis på ankomstdagen hvis der bestilles før kl. 12:00, eller der er brugt en aktiv rabatkode -->
                <!-- Bankoverførsel -->
                <div class="paymentOption bankxfer" v-if="payment.room === 'bankxfer' && (moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}).isSameOrAfter(moment().startOf('day').add({'hour': 12, 'minute': 0, 'second': 1})) || $store.getters.summaryData.totals.totalDiscount > 0 || $store.getters.discountCode != 0)" v-on:click="handleBanktransfer()">
                    <p class="headerText">{{ $t('bankxfer') }}</p>

                    <p v-if="$store.getters.summaryData.totals.totalPriceInclVat <= 0" class="priceText">{{ $t('pris') }} 0 kr.</p>
                    <p v-else class="priceText">{{ $t('pris') }} {{payment.pris*(1+(momssats/100))}} kr.</p>

                    <!-- <p class="subText" v-if="moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}).isSameOrAfter(moment())">{{ moment() }} er samme eller efter {{moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0})}}</p> -->
                    <p class="subText">{{ $t('betingelser') }}</p>
                </div>

                <!-- EAN faktura -->
                <div class="paymentOption ean" v-if="payment.room === 'prisean' && (moment($store.getters.bookingInProgress.startdate).add({'hour': 12, 'minute': 0, 'second': 0}).isSameOrAfter(moment().startOf('day').add({'hour': 12, 'minute': 0, 'second': 1})) || $store.getters.summaryData.totals.totalDiscount > 0  || $store.getters.discountCode != 0)" v-on:click="handleEAN()">
                    <p class="headerText">{{ $t('ean') }}</p>

                    <p v-if="$store.getters.summaryData.totals.totalPriceInclVat <= 0" class="priceText">{{ $t('pris') }} 0 kr.</p>
                    <p v-else class="priceText">{{ $t('pris') }} {{payment.pris*(1+(momssats/100))}} kr.</p>
                    
                </div>          
            </div>
        </div>

        <router-link to="oplysninger">
            <div class="tilbage">
                <p>&#171; {{$t('tilbagetekst')}}</p>
            </div>
        </router-link>

    </div>
</template>

<script>
import i18n from '@/plugins/i18n';
var moment = require('moment');
moment.locale('da');

export default {
    data() {
        return {
            locale: i18n.locale,
            apiLoaded: 0,
            QuickPayForm: {
                checksum: null,
                refNo: null, 
                //amount: this.$store.getters.summaryData.totals.totalPriceInclVat*100,
            },
            momssats: 25,   // Sæt default momssats til 25, bliver kun anvendt hvis /hotels ikke er loaded i Vuex
        };
    },
    created() {
        //this.buildRequest();
        // Lav API kald for at hente pris for de forskellige betalingstyper og momssats for hotellet
        this.$store.dispatch("getPaymentPriceData", {
            'koncern': this.$route.params.koncern,
            'hotel': this.$store.getters.bookingInProgress.hotel,
            'paymentType': 'bankxfer'
        }).then(() => {
            this.getMomssats(this.$store.getters.hotels);
            this.apiLoaded = 1});

        // Lav API kald for at kontrollere om kunden har indtastet en gyldig rabatkode
        this.$store.dispatch("checkDiscountCode", {
            'id': this.$store.getters.customerData.email2,
            'koncern': this.$route.params.koncern,
            'hotel': this.$store.getters.bookingInProgress.hotel,
            'start': this.$store.getters.bookingInProgress.startdate,
            'end': this.$store.getters.bookingInProgress.enddate,
        }).then(() => { this.apiLoaded = 1});
    },
    methods: {
        // Looper igennem alle hoteller fra Axios this.$store.getters.hotels og sætter momssats for det hotel der er valgt
        getMomssats(hotels) {
            for (const [hotel] of Object.entries(hotels)) {
                if(this.$store.getters.bookingInProgress.hotel == hotel.postnr) {
                    this.momssats = hotel.momssats;
                }
            }
        },
        handleBanktransfer() {
            this.apiLoaded = 0;

            this.$store.dispatch("getRefNo", {'koncern': this.$route.params.koncern, 'postnr': this.$store.getters.bookingInProgress.hotel}).then(
                () => { this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/faktura/'+this.$store.getters.refNo.refNo+'/initial/b' }) }
            )
        },
        handleEAN() {
            this.apiLoaded = 0;

            /* this.$store.dispatch("getRefNo", {'postnr': this.$store.getters.bookingInProgress.hotel}).then(
                () => { this.$router.push({ path: '/'+this.locale+'/faktura/'+this.$store.getters.refNo.refNo+'/initial/e' }) }
            ) */
            this.$router.push({ path: "betalingEAN" });
        },

        /**
         * 1. Opret et nyt 'tomt' referencenummer
         * 2. når 1 er færdig, så lad API-kald beregne checksum af QuickPay form-data
         * 3. når 2. er færdig, så sæt checksum værdi ind i form-data og 'klik' på submit-knappen på QuickPay formular
         */
        handleCreditCard() {
            this.apiLoaded = 0;
            var bookingInProgress = this.$store.getters.bookingInProgress;
            //delete bookingInProgress.detailedEkstras;   // detailedEkstras fylder for meget til QuickPay's 'continueurl'
            /**
             * Vi kan ikke slette detailedEkstras - så bliver fakturaen genereret uden detajerede ekstratilkøb
             * her skal der istedet køres en funktion som gennemgår detailedEkstras, og fjerner alle entries der 
             * ikke indeholder checked: true
             * Kun entries med checked: true er relevante i det videre forløb med generering af faktura.
             */


            this.$store.dispatch("getRefNo", {'koncern': this.$route.params.koncern, 'postnr': this.$store.getters.bookingInProgress.hotel}).then(
                () => { this.QuickPayForm.refNo = this.$store.getters.refNo.refNo; this.$store.dispatch("getChecksum", {'language': this.locale, 'amount': this.$store.getters.summaryData.totals.totalPriceInclVat*100, 'refNo': this.$store.getters.refNo.refNo, 'koncern': this.$route.params.koncern, 'postnr': this.$store.getters.bookingInProgress.hotel, 'customerData': this.$store.getters.customerData, 'bookingInProgress': bookingInProgress, 'adminOrder': '/2'}).then(
                    () => { this.QuickPayForm.checksum = this.$store.getters.checksum ; this.apiLoaded = 1; this.submitForm() }
                ) 
            }) 
        },
        submitForm() {
            if(this.QuickPayForm.checksum.checksum && this.QuickPayForm.checksum.checksum.length > 10) {
                document.forms[0].submit();
            }
        }
        // afslut med at redirecte til faktura: this.$router.push({ path: 'faktura/'+this.$store.getters.refNo.refNo+'/initial'
        
    }
}
</script>

<style scoped>
h1 {
  font-size: 400%;
  margin-bottom: 120px;
  font-weight: normal;
}

.paymentContainer {
    justify-content: center;
    align-items: center;
    margin-top: 100px;
    display: flex;
    flex-direction: row;
}

.headerText {
    font-size: 150%;
    margin-bottom: 0px;
    margin-top: -60px;
    height: 100px;
}

.priceText {
    margin-top: 0px;
    margin-bottom: 5px;
    font-size: 90%;

}

.subText {
    font-size: 50%;
}

.paymentOption {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 270px;
  height: 180px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 50px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.creditcard:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/betaling-betalingskort.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.bankxfer:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/betaling-bankxfer.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.ean:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/betaling-ean.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 293px;
  height: 80px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 150%;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  align-self: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 50px;
  margin-left: 0px;
  margin-right: 5%;
  float: right;
}

.tilbage {
    text-transform: none;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
}

@media screen and (max-width: 959px) {
    .paymentContainer {
        display: flex;
        flex-direction: column;
    }

    /* Mindre overskrift */
    h1 {
        font-size: 200%;
        margin-bottom: 0px;
    }
}


</style>